// M&M CART / MY AMAZON / OTHER AFFILIATE LINKS cart-drawer lists (Site Optimization). Moved out of the header group's Custom Liquid box
// (sections/header-group.json, custom_liquid_qYCNcy) into this cached file: ponytail audit #4 #6, Oct 31 2026 (~30 KB less HTML per page
// view, and the box is far from Shopify's 50 KB per-setting limit). Settings still come from #mm-amzd-cfg in that box (Liquid values).
// Plain .js: Liquid does NOT work here. Full history of these notes: git history of sections/header-group.json.
(function () {
  if (window.__mmAmzDrawer) return; window.__mmAmzDrawer = true;
  var KEY = "mm-amazon-list", EVT = "mm:amazon-list", MAXQ = 20;
  var ASIN_RE = /(?:\/dp\/|\/gp\/product\/|\/gp\/aw\/d\/|\/o\/ASIN\/)([A-Z0-9]{10})(?=[\/?#&]|$)/i;
  var AMZ_HOST = /^https:\/\/((www|smile)\.)?amazon\.com\//i;
  var cfg = document.getElementById("mm-amzd-cfg");
  var TAG = cfg ? (cfg.getAttribute("data-tag") || "").trim() : "";
  var PAGE = cfg ? cfg.getAttribute("data-page") : "/pages/my-amazon-list";
  var OKEY = "mm-other-list", OEVT = "mm:other-list", OK_HOST = /^https:\/\/((www\.)?etsy\.com|aquaticmotiv\.com)\//i;
  var PROMOS = {}; try { PROMOS = JSON.parse((cfg && cfg.getAttribute("data-promos")) || "{}") || {}; } catch (e) { PROMOS = {}; }

  var PAL = { k: "#12322a", y: "#fed46c", d: "#e9b52f", w: "#ffffff", s: "#c3d0ca", S: "#6f8079",
              b: "#4fb6e8", B: "#156ea8", g: "#46db7a", G: "#1d7a44", o: "#fe8503", r: "#d23a43",
              n: "#c58b4c", N: "#7a4f25", t: "#3a2a00" };
  var ICONS = {
    light:  ["............","kkkkkkkkkkkk","kSSSSSSSSSSk","kwywywywywyk","kkkkkkkkkkkk","k..y..y..y.k","k.y..y..y..k","ky..y..y..yk","k..........k","k..........k","kk........kk","............"],
    heater: [".....kk.....","....kSSk....","....kSSk....","....kkkk....","....kwbk....","....kwok....","....kwok....","....kwok....","....kwok....","....kwbk....",".....kk.....","............"],
    filter: ["............",".kkkkkkkk...",".kSSSSSSkk..",".ksssssskbk.",".ksssssskbk.",".kssssssk.b.",".kssssssk.b.",".kkkkkkkk.b.","..kk......b.","..ks.....bbb","..kk........","............"],
    sponge: [".....kk.....",".....kk.....",".kkkkkkkkkk.",".kSSSSSSSSk.",".kkkkkkkkkk.",".ksSsk.ksSsk",".kSsSk.kSsSk",".ksSsk.ksSsk",".kSsSk.kSsSk",".ksSsk.ksSsk",".kkkkk.kkkkk","............"],
    pump:   ["..........b.",".........b..","..........b.",".kkkkkkk.k..",".kSSSSSk.k..",".kSwSwSkkk..",".kSSSSSk....",".kSSSSSk....",".kkkkkkk....","..k...k.....","............","............"],
    stone:  ["....b..b....",".....b..b...","....b..b....",".....b.b....","............","...kkkkkk...","..kssssssk..","..kSsSsSsk..","..kssssssk..","...kkkkkk...",".....kk.....",".....kk....."],
    test:   [".kk..kk.....",".kk..kk...k.","kwwkkwwk.kwk","kbbkkook.kgk","kbbkkook.kgk","kbbkkook.kgk","kbbkkook.kgk","kkkkkkkk.kgk",".........kgk","..........k.","............","............"],
    tds:    ["....kkkk....","....kSSk....","...kkkkkk...","...kwwwwk...","...kBgBgk...","...kwwwwk...","...kSSSSk...","...kSwSSk...","...kSSSSk...","...kSSSSk...","....kkkk....",".....kk....."],
    bag:    ["............","..kkkkkkkk..","..kyyyyyyk..",".kyyyyyyyyk.",".kyGGGGGGyk.",".kyGwwwwGyk.",".kyGGGGGGyk.",".kyNnNnNnyk.",".knNnNnNnNk.",".kNnNnNnNnk.",".kkkkkkkkkk.","............"],
    food:   ["............","...kkkkkk...","...kooook...","..kkkkkkkk..","..kwwwwwwk..","..kwgGgGwk..","..kwGgGgwk..","..kwgGgGwk..","..kwGgGgwk..","..kwwwwwwk..","..kkkkkkkk..","............"],
    bottle: [".....kk.....","....kook....","....kkkk....","....kwwk....","...kwwwwk...","..kwggggwk..","..kgGGGGgk..","..kgGwwGgk..","..kgGGGGgk..","..kggggggk..","..kkkkkkkk..","............"],
    co2:    ["...kkkkk....","...kSwSk.kk.","...kkSkkkSk.","....kSk..kk.","...kkkkk....","..krrrrrk...","..krwrrrk...","..krwrrrk...","..krrrrrk...","..krrrrrk...","..krrrrrk...","..kkkkkkk..."],
    tank:   ["............","kkkkkkkkkkkk","kwbbbbbbbbwk","kbbbbbbbbbbk","kbbbgbbbbbbk","kbbgGbbgbbbk","kbbgGbgGbbbk","knnnnnnnnnnk","kkkkkkkkkkkk",".kk......kk.","............","............"],
    box:    ["............","............","..kkkkkkkk..",".knnnnnnnnk.","kkkkkkkkkkkk","knnnnyynnnnk","knnnnyynnnnk","knnnnnnnnnnk","knnnnnnnnnnk","knnnnnnnnnnk","kkkkkkkkkkkk","............"]
  };
  var CART = ["##..............","##..............",".#..............",".##############.",".#YYYYYYYYYYYY#.",".#YYYYYAAYYYYY#.",".#YYYYAYYAYYYY#.",".#YYYYAAAAYYYY#.",".#YYYYAYYAYYYY#.","..#DDDADDADDD#..","..############..","...#........#...","..###......###..","...#........#..."];

  function svgFrom(grid, pal, px) {
    var h = grid.length, w = grid[0].length, r = "";
    for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) {
      var c = pal[grid[y].charAt(x)];
      if (c) r += '<rect x="' + x + '" y="' + y + '" width="1" height="1" fill="' + c + '"/>';
    }
    return '<svg xmlns="http://www.w3.org/2000/svg" width="' + (w * px) + '" height="' + (h * px) + '" viewBox="0 0 ' + w + " " + h + '" shape-rendering="crispEdges" aria-hidden="true">' + r + "</svg>";
  }
  function outlined(grid) {
    var h = grid.length, w = grid[0].length, g = [];
    for (var y = 0; y < h + 2; y++) { g.push([]); for (var x = 0; x < w + 2; x++) g[y].push(y && x && y <= h && x <= w ? grid[y - 1].charAt(x - 1) : "."); }
    for (y = 0; y < h + 2; y++) for (x = 0; x < w + 2; x++) {
      if (g[y][x] !== ".") continue;
      for (var dy = -1; dy <= 1; dy++) for (var dx = -1; dx <= 1; dx++) {
        var yy = y + dy, xx = x + dx;
        if (yy >= 0 && xx >= 0 && yy < h + 2 && xx < w + 2 && "#YDA".indexOf(g[yy][xx]) > -1) g[y][x] = "W";
      }
    }
    return g.map(function (row) { return row.join(""); });
  }
  var CART_ICON = svgFrom(outlined(CART), { "#": "#12322a", Y: "#fed46c", D: "#e9b52f", A: "#3a2a00", W: "#ffffff" }, 2);
  var CART_MINI = svgFrom(CART, { "#": "#3a2a00", Y: "#fed46c", D: "#e9b52f", A: "#3a2a00" }, 2);

  function iconFor(it) {
    if (it.icon && ICONS[it.icon]) return it.icon;
    var n = it.name.toLowerCase();
    if (/co2|co₂/.test(n)) return "co2";
    if (/heater/.test(n)) return "heater";
    if (/\bled\b|light/.test(n)) return "light";
    if (/sponge/.test(n)) return "sponge";
    if (/air ?stone/.test(n)) return "stone";
    if (/pump/.test(n)) return "pump";
    if (/\btds\b/.test(n)) return "tds";
    if (/test/.test(n)) return "test";
    if (/soil|sand|gravel|substrate/.test(n)) return "bag";
    if (/food|cuisine|pellet|wafer/.test(n)) return "food";
    if (/filter|\bhob\b|canister/.test(n)) return "filter";
    if (/flourish|tabs|excel|mineral|bacteria|one & only|conditioner|fert|remineral/.test(n)) return "bottle";
    if (/tank|aquarium/.test(n)) return "tank";
    return "box";
  }

  /* ---------- the shared list (same rules as the Amazon cart page) ---------- */
  function norm(x) {
    var asin = String(x.asin || "").toUpperCase();
    if (!/^[A-Z0-9]{10}$/.test(asin)) { var m = String(x.url || "").match(ASIN_RE); asin = m ? m[1].toUpperCase() : ""; }
    var q = parseInt(x.qty, 10); if (!(q >= 1)) q = 1; if (q > MAXQ) q = MAXQ;
    var url = String(x.url || ""); if (!AMZ_HOST.test(url)) url = "";
    return { id: String(x.id || asin || x.name), name: String(x.name), url: url, asin: asin, qty: q,
             note: x.note ? String(x.note) : "", icon: x.icon ? String(x.icon) : "",
             img: /^(https:)?\/\/(cdn\.shopify\.com|(www\.)?mossandmolt\.com\/cdn)\//.test(String(x.img || "")) ? String(x.img) : "", page: /^\/products\/[a-z0-9-]+(\?variant=\d+)?$/.test(String(x.page || "")) ? String(x.page) : "" };
  }
  function load() {
    var raw; try { raw = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) { raw = []; }
    if (!Array.isArray(raw)) raw = [];
    var out = [], seen = {};
    raw.forEach(function (x) {
      if (!x || !x.name) return;
      var it = norm(x);
      if (seen[it.id]) { seen[it.id].qty = Math.min(MAXQ, seen[it.id].qty + it.qty); return; }
      seen[it.id] = it; out.push(it);
    });
    return out;
  }
  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent(EVT, { detail: { count: list.length } })); } catch (e) {}
  }
  function productUrl(it) {
    if (it.asin) return "https://www.amazon.com/dp/" + it.asin + (TAG ? "?tag=" + encodeURIComponent(TAG) : "");
    if (!it.url) return "";
    if (!TAG || /[?&]tag=/.test(it.url)) return it.url;
    return it.url + (it.url.indexOf("?") > -1 ? "&" : "?") + "tag=" + encodeURIComponent(TAG);
  }
  function cartUrl(list) {
    var merged = {}, order = [];
    list.forEach(function (it) { if (!it.asin) return; if (!merged[it.asin]) { merged[it.asin] = 0; order.push(it.asin); } merged[it.asin] += it.qty; });
    if (!order.length) return "";
    var p = order.map(function (a, i) { return "ASIN." + (i + 1) + "=" + a + "&Quantity." + (i + 1) + "=" + Math.min(merged[a], 99); });
    if (TAG) p.push("AssociateTag=" + encodeURIComponent(TAG));
    return "https://www.amazon.com/gp/aws/cart/add.html?" + p.join("&");
  }
  /* ---------- Other Affiliate Links (v3.3) ---------- */
  function loadOther() {
    var raw; try { raw = JSON.parse(localStorage.getItem(OKEY) || "[]"); } catch (e) { raw = []; }
    if (!Array.isArray(raw)) raw = [];
    var out = [], seen = {};
    raw.forEach(function (x) {
      if (!x || !x.name || !OK_HOST.test(String(x.url || ""))) return;
      var q = parseInt(x.qty, 10); if (!(q >= 1)) q = 1; if (q > MAXQ) q = MAXQ;
      var it = { id: String(x.id || x.url), name: String(x.name), url: String(x.url), seller: String(x.seller || "Other shop"), qty: q };
      if (seen[it.id]) return; seen[it.id] = it; out.push(it);
    });
    return out;
  }
  function saveOther(list) {
    try { localStorage.setItem(OKEY, JSON.stringify(list)); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent(OEVT, { detail: { count: list.length } })); } catch (e) {}
  }
  function promoFor(seller) {
    var base = seller.replace(/\s*\(Etsy\)$/, "");
    var c = PROMOS && (PROMOS[seller] || PROMOS[base]);
    return typeof c === "string" && /^[A-Za-z0-9_-]{2,30}$/.test(c) ? c : "";
  }
  function CSS_ESC(s) { return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/["\\]/g, "\\$&"); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); }

  /* ---------- two areas in the cart drawer: M&M CART and AMAZON CART ---------- */
  var BASE =
    ":host{display:block;align-self:stretch;text-align:left}*{box-sizing:border-box}[hidden]{display:none!important}" +
    ".bar{display:flex;align-items:center;gap:10px;padding:8px 12px 7px;font-family:'Atkinson Hyperlegible',system-ui,sans-serif;font-size:13px;line-height:1.2}" +
    ".bar svg{display:block;image-rendering:pixelated;flex:none}" +
    ".bar b{font-family:'Jersey 20',ui-monospace,monospace;font-weight:400;font-size:18px;line-height:1;letter-spacing:.05em;text-transform:uppercase}" +
    ".bar span{color:#8fb3d1}.bar a{margin-left:auto;color:#e8f4ff;white-space:nowrap}" +
    ":focus-visible{outline:3px solid #02d1f5;outline-offset:2px}";
  var MM_CSS = BASE +
    ":host{margin:14px var(--cart-drawer-padding,16px) 6px}" +
    ".bar{background:#06294a;box-shadow:0 0 0 2px #3ba2db,4px 5px 0 0 #010d1b}.bar b{color:#e8f4ff}" +
    ".tabs{display:flex;gap:10px}.tabs button{flex:1 1 0;justify-content:center;border:0;cursor:pointer;color:#8fb3d1;background:#010d1b;box-shadow:0 0 0 2px #174b77}" +
    ".tabs button b{color:#8fb3d1}.tabs [aria-selected=true]{background:#06294a;box-shadow:0 0 0 2px #3ba2db,4px 5px 0 0 #010d1b}.tabs [aria-selected=true] b{color:#78cef9}" +
    ".tabs [data-tab=amz][aria-selected=true]{background:#2a2200;box-shadow:0 0 0 2px #8a6a14,4px 5px 0 0 #010d1b}.tabs [data-tab=amz][aria-selected=true] b{color:#fed46c}";
  var AMZ_CSS = BASE +
    ":host{margin:18px var(--cart-drawer-padding,16px) 16px}" +
    ".bar{background:#2a2200;box-shadow:0 0 0 2px #8a6a14}.bar b{color:#fed46c}" +
    ".box{color:#e8f4ff;font-family:'Atkinson Hyperlegible',system-ui,sans-serif;font-size:14px;line-height:1.4;background:#06294a;box-shadow:0 0 0 2px #8a6a14,4px 5px 0 0 #010d1b}" +
    ".in{padding:4px 12px 12px}" +
    "ul{list-style:none;margin:0;padding:0}" +
    "li{display:grid;grid-template-columns:44px minmax(0,1fr) auto;gap:10px;align-items:center;padding:8px 0;border-top:2px solid #174b77}li:first-child{border-top:0}" +
    ".tile{width:44px;height:44px;display:grid;place-items:center;background:#e2f3fa;box-shadow:0 0 0 2px #3ba2db}.tile svg{display:block;image-rendering:pixelated}.tile img{width:40px;height:40px;object-fit:contain;image-rendering:pixelated;display:block}" +
    ".nm{font-weight:700;overflow-wrap:anywhere}.nm a{color:inherit;text-decoration:none}.nm a:hover{text-decoration:underline}" +
    ".sub{display:block;font-size:12px;color:#8fb3d1;font-weight:400}" +
    ".ctl{display:flex;align-items:center;gap:6px}" +
    ".st{display:inline-flex;align-items:center;box-shadow:0 0 0 2px #3ba2db;background:#010d1b}" +
    ".st button,.rm{width:30px;height:30px;border:0;cursor:pointer;font-family:'Jersey 20',ui-monospace,monospace;font-size:17px;line-height:1;padding:0}" +
    ".st button{background:#0a3a63;color:#e8f4ff}.st button:disabled{color:#174b77;cursor:default}" +
    ".st output{min-width:26px;text-align:center;font-weight:700;font-variant-numeric:tabular-nums}" +
    ".rm{background:transparent;color:#8fb3d1;box-shadow:0 0 0 2px #174b77}.rm:hover{color:#ff6b5e;box-shadow:0 0 0 2px #ff6b5e}" +
    ".go{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:10px;text-decoration:none;font-family:'Jersey 20',ui-monospace,monospace;font-size:17px;line-height:1;letter-spacing:.04em;text-transform:uppercase;padding:9px 10px 8px;background:#fed46c;color:#3a2a00;box-shadow:0 0 0 2px #12322a,inset 0 -3px 0 #e9b52f}" +
    ".go:hover{background:#ffe08f}.go svg{display:block;image-rendering:pixelated;flex:none}" +
    ".empty{margin:8px 0 0;color:#8fb3d1}.empty a{color:#e8f4ff}" +
    ".miss{margin:8px 0 0;font-size:12px;color:#fed46c}" +
    ".fine{margin:8px 0 0;font-size:12px;color:#8fb3d1}" +
    ".clr{display:block;width:100%;margin-top:10px;padding:8px 10px 7px;background:transparent;border:0;cursor:pointer;font-family:'Jersey 20',ui-monospace,monospace;font-size:16px;line-height:1;letter-spacing:.04em;text-transform:uppercase;color:#8fb3d1;box-shadow:0 0 0 2px #174b77}" +
    ".clr:hover,.clr.armed{color:#ff6b5e;box-shadow:0 0 0 2px #ff6b5e}";

  var OTH_CSS = BASE +
    ":host{margin:0 var(--cart-drawer-padding,16px) 16px}" +
    ".bar{background:#0f2a1c;box-shadow:0 0 0 2px #2f8a57}.bar b{color:#7fe0a4}" +
    ".box{color:#e8f4ff;font-family:'Atkinson Hyperlegible',system-ui,sans-serif;font-size:14px;line-height:1.4;background:#06294a;box-shadow:0 0 0 2px #2f8a57,4px 5px 0 0 #010d1b}" +
    ".in{padding:4px 12px 12px}ul{list-style:none;margin:0;padding:0}" +
    ".shop{margin-top:10px;padding:8px 10px;background:#0a3a2a;box-shadow:0 0 0 2px #2f8a57}.shop:first-child{margin-top:6px}" +
    ".sh{display:flex;flex-wrap:wrap;align-items:center;gap:6px 10px;font-weight:700;color:#7fe0a4}" +
    ".code{display:inline-flex;align-items:center;gap:6px;font-weight:400;color:#e8f4ff;font-size:13px}" +
    ".code kbd{font-family:'Jersey 20',ui-monospace,monospace;font-size:16px;letter-spacing:.06em;padding:2px 6px;background:#010d1b;box-shadow:0 0 0 2px #2f8a57;color:#fed46c}" +
    ".cp{border:0;cursor:pointer;padding:4px 8px;background:#2f8a57;color:#06120c;font-weight:700;font-size:12px}" +
    "li{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:10px;align-items:center;padding:7px 0;border-top:2px solid #174b77}li:first-child{border-top:0}" +
    ".nm{font-weight:700;overflow-wrap:anywhere}.nm a{color:#e8f4ff;text-decoration:none}.nm a:hover{text-decoration:underline}" +
    ".ctl{display:flex;align-items:center;gap:6px}.st{display:inline-flex;align-items:center;box-shadow:0 0 0 2px #3ba2db;background:#010d1b}" +
    ".st button,.rm{width:30px;height:30px;border:0;cursor:pointer;font-family:'Jersey 20',ui-monospace,monospace;font-size:17px;line-height:1;padding:0}" +
    ".st button{background:#0a3a63;color:#e8f4ff}.st button:disabled{color:#174b77;cursor:default}" +
    ".st output{min-width:26px;text-align:center;font-weight:700;font-variant-numeric:tabular-nums}" +
    ".rm{background:transparent;color:#8fb3d1;box-shadow:0 0 0 2px #174b77}.rm:hover{color:#ff6b5e;box-shadow:0 0 0 2px #ff6b5e}" +
    ".empty{margin:8px 0 0;color:#8fb3d1}.empty a{color:#e8f4ff}.fine{margin:8px 0 0;font-size:12px;color:#8fb3d1}" +
    ".clr{display:block;width:100%;margin-top:10px;padding:8px 10px 7px;background:transparent;border:0;cursor:pointer;font-family:'Jersey 20',ui-monospace,monospace;font-size:16px;line-height:1;letter-spacing:.04em;text-transform:uppercase;color:#8fb3d1;box-shadow:0 0 0 2px #174b77}" +
    ".clr:hover,.clr.armed{color:#ff6b5e;box-shadow:0 0 0 2px #ff6b5e}";
  function renderOther(host) {
    var root = host.shadowRoot, list = loadOther(), body;
    if (!list.length) { host.hidden = true; host.style.display = "none"; root.innerHTML = ""; return; }   /* Oct 23 2026: hidden till used, like My Amazon List */
    host.hidden = false; host.style.display = "block";
    var units = list.reduce(function (s, x) { return s + x.qty; }, 0);
    if (!list.length) body = '<p class="empty">Nothing here yet. Items from Etsy shops and Aquatic Motiv land here when you tap Add build to cart in the <a href="/pages/aquarium-sim">Aquarium Sim</a>.</p>';
    else {
      var groups = {}, order = [];
      list.forEach(function (it) { if (!groups[it.seller]) { groups[it.seller] = []; order.push(it.seller); } groups[it.seller].push(it); });
      body = order.map(function (sel) {
        var code = promoFor(sel);
        return '<div class="shop" role="group" aria-label="' + esc(sel) + '"><div class="sh">' + esc(sel) +
          (code ? '<span class="code">Code <kbd>' + esc(code) + '</kbd><button type="button" class="cp" data-act="copy" data-code="' + esc(code) + '">Copy</button></span>' : "") + "</div><ul>" +
          groups[sel].map(function (it) {
            var nm = esc(it.name);
            return '<li><span class="nm"><a href="' + esc(it.url) + '" target="_blank" rel="noopener nofollow">' + nm + " ↗</a></span>" +
              '<span class="ctl"><span class="st"><button type="button" data-act="dec" data-id="' + esc(it.id) + '" aria-label="One fewer ' + nm + '"' + (it.qty <= 1 ? " disabled" : "") + ">−</button>" +
              '<output aria-label="Quantity of ' + nm + '">' + it.qty + "</output>" +
              '<button type="button" data-act="inc" data-id="' + esc(it.id) + '" aria-label="One more ' + nm + '"' + (it.qty >= MAXQ ? " disabled" : "") + ">+</button></span>" +
              '<button type="button" class="rm" data-act="rm" data-id="' + esc(it.id) + '" aria-label="Remove ' + nm + '">×</button></span></li>';
          }).join("") + "</ul></div>";
      }).join("") +
      '<button type="button" class="clr" data-act="clear">Clear this list</button>' +
      '<p class="fine">These open the other shop’s own page. Price, stock and shipping are set by that shop.</p>';
    }
    root.innerHTML = "<style>" + OTH_CSS + "</style>" +
      '<section class="box" aria-label="Other Affiliate Links">' +
        '<div class="bar" role="heading" aria-level="2"><b>Other Affiliate Links</b><span>' + count(units) + "</span></div>" +
        '<div class="in">' + body + "</div></section>";
  }
  function onOtherClick(host) {
    return function (e) {
      var b = e.target.closest("button[data-act]"); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var id = b.getAttribute("data-id"), act = b.getAttribute("data-act"), list = loadOther();
      if (act === "copy") { var c = b.getAttribute("data-code"); try { navigator.clipboard.writeText(c); b.textContent = "Copied"; } catch (x) {} return; }
      if (act === "clear") {
        if (!host.__mmArmed) { host.__mmArmed = setTimeout(function () { host.__mmArmed = 0; renderOther(host); }, 4000); b.textContent = "Tap again to empty"; b.classList.add("armed"); return; }
        clearTimeout(host.__mmArmed); host.__mmArmed = 0; saveOther([]); renderAll(); return;
      }
      list.forEach(function (x) { if (x.id === id) { if (act === "inc") x.qty = Math.min(MAXQ, x.qty + 1); if (act === "dec") x.qty = Math.max(1, x.qty - 1); } });
      if (act === "rm") list = list.filter(function (x) { return x.id !== id; });
      saveOther(list); renderAll();
      var again = act === "rm" ? null : host.shadowRoot.querySelector('button[data-act="' + act + '"][data-id="' + CSS_ESC(id) + '"]:not(:disabled)');
      var target = again || host.shadowRoot.querySelector("button, a"); if (target) target.focus();
    };
  }
  function count(n) { return n + (n === 1 ? " item" : " items"); }
  function mmCount(content) {
    var drawer = content.closest("#cart-drawer");
    if (drawer && drawer.querySelector(".cart-drawer--empty")) return 0;
    var badge = drawer && drawer.querySelector(".theme-drawer__badge");
    var n = badge ? parseInt(badge.textContent, 10) : NaN;
    return isNaN(n) ? null : n;
  }
  /* Oct 29 2026, 1:51 p.m. (David: "move the amazon cart to be like a second page at the top where you can switch between the M&M Cart
     and AMZN Cart"): with Amazon picks saved, the M&M Cart bar is two tabs; AMZN shows only My Amazon List (html.mm-cart-amz, page style
     below). No picks = the plain M&M Cart bar. ~~Amazon list dropdown above checkout (v0.0.291)~~ dead. */
  function renderMM(host) {
    /* Oct 29 2026, 1:59 p.m. (David): Other Affiliate Links live on the AMZN tab too, so its count includes them */
    var n = mmCount(host.parentNode || host), a = load().concat(loadOther()).reduce(function (s, x) { return s + x.qty; }, 0);
    var amz = a > 0 && document.documentElement.classList.contains("mm-cart-amz");
    if (!a) document.documentElement.classList.remove("mm-cart-amz");
    var mmLbl = "<b>M&amp;M Cart</b>" + (n === null ? "" : "<span>" + count(n) + "</span>");
    host.shadowRoot.innerHTML = "<style>" + MM_CSS + "</style>" + (a ?
      '<div class="tabs" role="tablist" aria-label="Carts">' +
        '<button type="button" class="bar" role="tab" data-tab="mm" aria-selected="' + !amz + '">' + mmLbl + "</button>" +
        '<button type="button" class="bar" role="tab" data-tab="amz" aria-selected="' + amz + '"><b>AMZN Cart</b><span>' + count(a) + "</span></button></div>" :
      '<div class="bar" role="heading" aria-level="2">' + mmLbl + "</div>");
  }
  function onTab(e) {
    var b = e.target.closest && e.target.closest("button[data-tab]"); if (!b) return;
    document.documentElement.classList.toggle("mm-cart-amz", b.getAttribute("data-tab") === "amz");
    renderAll();
    var again = this.querySelector('button[data-tab="' + b.getAttribute("data-tab") + '"]'); if (again) again.focus();
  }
  function renderAmz(host) {
    var root = host.shadowRoot, list = load();
    /* Oct 23 2026, 12:55 p.m. (David: "only show the amazon cart area if the user added items with amazon affiliate links to their cart,
       aka hidden till active"): an empty list hides the whole box; ~~"Nothing on your list yet" box~~ dead. */
    if (!list.length) { host.hidden = true; host.style.display = "none"; root.innerHTML = ""; return; }
    host.hidden = false; host.style.display = "block";
    var units = list.reduce(function (s, x) { return s + x.qty; }, 0);
    var go = cartUrl(list), miss = list.filter(function (x) { return !x.asin; }).length;
    var body;
    if (!list.length) {
      body = '<p class="empty">Nothing on your list yet. Tap + Add to My Amazon List on any AMAZON product, or the + in the <a href="/pages/aquarium-sim">Aquarium Sim</a> or <a href="/pages/para-medic">Para-Medic</a>. <a href="' + esc(PAGE) + '">Open My Amazon List</a></p>';
    } else {
      body = "<ul>" + list.map(function (it) {
          var nm = esc(it.name), url = productUrl(it);
          return '<li><span class="tile">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" width="40" height="40" loading="lazy">' : svgFrom(ICONS[iconFor(it)], PAL, 3)) + "</span>" +
            '<span class="nm">' + (url ? '<a href="' + esc(url) + '" target="_blank" rel="sponsored noopener">' + nm + "</a>" : nm) +
              (it.note ? '<span class="sub">' + esc(it.note) + "</span>" : "") + (it.asin ? "" : '<span class="sub">Not in one-click</span>') + "</span>" +
            '<span class="ctl"><span class="st"><button type="button" data-act="dec" data-id="' + esc(it.id) + '" aria-label="One fewer ' + nm + '"' + (it.qty <= 1 ? " disabled" : "") + ">−</button>" +
              '<output aria-label="Quantity of ' + nm + '">' + it.qty + "</output>" +
              '<button type="button" data-act="inc" data-id="' + esc(it.id) + '" aria-label="One more ' + nm + '"' + (it.qty >= MAXQ ? " disabled" : "") + ">+</button></span>" +
              '<button type="button" class="rm" data-act="rm" data-id="' + esc(it.id) + '" aria-label="Remove ' + nm + '">×</button></span></li>';
        }).join("") + "</ul>" +
        (go ? '<a class="go" href="' + esc(go) + '" target="_blank" rel="sponsored noopener">' + CART_MINI + "Add all to Amazon</a>" : "") +
        '<button type="button" class="clr" data-act="clear">Clear my list</button>' +
        (miss ? '<p class="miss">' + (miss === 1 ? "1 item isn't" : miss + " items aren't") + " in the one-click cart yet. Tap its name to find it on Amazon.</p>" : "") +
        '<p class="fine">As an Amazon Associate, we earn from qualifying purchases.</p>'   /* Oct 17 2026: the rest is in the blinking "i" note */;
    }
    root.innerHTML = "<style>" + AMZ_CSS + "</style>" +
      '<section class="box" aria-label="My Amazon List">' +
        '<div class="bar" role="heading" aria-level="2">' + CART_ICON + "<b>My Amazon List</b><span>" + count(units) + '</span><a href="' + esc(PAGE) + '">Open list</a></div>' +
        '<div class="in">' + body + "</div></section>";
  }

  function makeHost(cls) {
    /* v3.4 Oct 20 2026 (tester Mitch, Brave: Checkout vanished after Back from checkout): a custom tag, not a div, so Horizon's cart morph (assets/morph.js matches children by tag) never reuses one of these shadow hosts as the real Checkout area and hides it */
    var host = document.createElement("mm-cart-box");
    host.style.display = "block";
    host.className = cls;
    host.attachShadow({ mode: "open" });
    return host;
  }
  function onAmzClick(host) {
    return function (e) {
      var b = e.target.closest("button[data-act]"); if (!b) return;
      e.preventDefault(); e.stopPropagation();
      var id = b.getAttribute("data-id"), act = b.getAttribute("data-act"), list = load();
      if (act === "clear") { // two taps, so a stray tap can't wipe the list
        if (!host.__mmArmed) {
          host.__mmArmed = setTimeout(function () { host.__mmArmed = 0; renderAmz(host); }, 4000);
          b.textContent = "Tap again to empty"; b.classList.add("armed"); return;
        }
        clearTimeout(host.__mmArmed); host.__mmArmed = 0;
        save([]); renderAll();
        var f = host.shadowRoot.querySelector("a, button"); if (f) f.focus();
        return;
      }
      list.forEach(function (x) { if (x.id === id) { if (act === "inc") x.qty = Math.min(MAXQ, x.qty + 1); if (act === "dec") x.qty = Math.max(1, x.qty - 1); } });
      if (act === "rm") list = list.filter(function (x) { return x.id !== id; });
      save(list); renderAll();
      var again = act === "rm" ? null : host.shadowRoot.querySelector('button[data-act="' + act + '"][data-id="' + CSS_ESC(id) + '"]:not(:disabled)');
      var target = again || host.shadowRoot.querySelector("button, a");
      if (target) target.focus();
    };
  }
  /* with the M&M cart empty, Horizon centers the drawer's contents; keep the two areas at the top instead */
  function addPageStyle() {
    if (document.getElementById("mm-amzd-style")) return;
    var st = document.createElement("style");
    st.id = "mm-amzd-style";
    st.textContent = "#cart-drawer .cart-drawer__content:has(> .mm-mmbar){justify-content:flex-start!important}" +
      "#cart-drawer .cart-drawer--empty .cart-drawer__content > h2{margin-block:18px 6px}" +
      /* Oct 29 2026, 12:39 p.m. + 1:51 p.m. (David: "The only thing that should be locked in place are the 'cart' at the top left of the
         cart, the checkout buttons"): the whole cart scrolls as one (Horizon let the item list scroll on its own, so everything else looked
         locked); the summary box dissolves (display:contents) so only Checkout sticks to the bottom (Horizon un-sticks the whole summary when
         it is over half the drawer). v0.0.291 cut off the total on computers (width:100% plus side margins); ~~totals margin, width 100%~~ dead. */
      "#cart-drawer .cart-drawer__content>*,#cart-drawer .cart-drawer__summary>*{flex-shrink:0}" +
      "#cart-drawer .cart-drawer__items{overflow:visible}" +
      "#cart-drawer .cart-drawer__summary{display:contents}" +
      "#cart-drawer .cart-drawer__summary>.cart-totals{width:auto;margin-top:auto;padding:var(--cart-drawer-summary-padding,16px) var(--cart-drawer-summary-padding,16px) 0}" +
      "#cart-drawer .cart-drawer__summary>.cart__ctas{position:sticky;bottom:0;z-index:2;width:auto;margin:0;padding:12px var(--cart-drawer-summary-padding,16px) var(--cart-drawer-summary-padding,16px);" +
      "background:var(--color-background);border-top:2px solid #174b77}" +
      "html.mm-cart-amz #cart-drawer .cart-drawer__content>:not(.mm-mmbar):not(.mm-amzd):not(.mm-othd){display:none!important}" +
      "html:not(.mm-cart-amz) #cart-drawer .cart-drawer__content>:is(.mm-amzd,.mm-othd){display:none!important}";
    document.head.appendChild(st);
  }

  var mmHosts = [], amzHosts = [], othHosts = [];
  function attach() {
    document.querySelectorAll("#cart-drawer .cart-drawer__content").forEach(function (content) {
      if (!content.querySelector(":scope > .mm-mmbar")) {
        var mm = makeHost("mm-mmbar");
        mm.shadowRoot.addEventListener("click", onTab);
        content.insertBefore(mm, content.firstElementChild);
        mmHosts.push(mm);
      }
      if (!content.querySelector(":scope > .mm-amzd")) {
        var amz = makeHost("mm-amzd");
        amz.shadowRoot.addEventListener("click", onAmzClick(amz));
        var summary = content.querySelector(":scope > .cart-drawer__summary");
        if (summary) content.insertBefore(amz, summary); else content.appendChild(amz);
        amzHosts.push(amz); renderAmz(amz);
      }
      /* Oct 22 2026, 2:27 p.m. (David: "Just put a shipping page link in the cart fly out. Above the Amazon cart to avoid confusion"): a
         link to the Shipping & Weather page (/pages/shipping) right above My Amazon List, so the M&M cart's shipping info isn't mixed up
         with Amazon's. Same custom-tag shadow host as the other two boxes (v3.4 morph fix). */
      /* ~~Shipping info link host (Oct 22 2026)~~ dead Oct 30 2026 (David, 11:13 a.m.: "get rid of the When it ships box and just loop it into the shipping info as part of its drop down"): Shipping info is now a server-rendered dropdown, snippets/mm-ship-days.liquid style cart, placed in snippets/cart-drawer.liquid. */
      if (!content.querySelector(":scope > .mm-othd")) {   // v3.3: right under My Amazon List
        var oth = makeHost("mm-othd"), after = content.querySelector(":scope > .mm-amzd");
        oth.shadowRoot.addEventListener("click", onOtherClick(oth));
        if (after && after.nextSibling) content.insertBefore(oth, after.nextSibling); else content.appendChild(oth);
        othHosts.push(oth); renderOther(oth);
      }
    });
    mmHosts = mmHosts.filter(function (h) { return h.isConnected; });
    amzHosts = amzHosts.filter(function (h) { return h.isConnected; });
    othHosts = othHosts.filter(function (h) { return h.isConnected; });
    mmHosts.forEach(renderMM);
  }
  function renderAll() { attach(); amzHosts.forEach(renderAmz); othHosts.forEach(renderOther); }

  function start() {
    addPageStyle();
    attach();
    var drawer = document.getElementById("cart-drawer");
    if (drawer && window.MutationObserver) {
      new MutationObserver(function (muts) {
        var opened = muts.some(function (m) { return m.type === "attributes"; });
        if (opened) renderAll(); else attach();
      }).observe(drawer, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["open"] });
    }
  }
  /* v3: any tool on the page (Aquarium Doctor, Tank Builder...) that saves Amazon picks now updates the drawer at once */
  try {
    var _set = Storage.prototype.setItem, _rm = Storage.prototype.removeItem;
    Storage.prototype.setItem = function (k, v) { _set.apply(this, arguments); if ((k === KEY || k === OKEY) && this === window.localStorage) setTimeout(renderAll, 0); };
    Storage.prototype.removeItem = function (k) { _rm.apply(this, arguments); if ((k === KEY || k === OKEY) && this === window.localStorage) setTimeout(renderAll, 0); };
  } catch (e) {}
  document.addEventListener("click", function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-testid="cart-drawer-trigger"], [on\\:click="#cart-drawer/toggle"], .header-actions__cart-icon');
    if (t) { renderAll(); setTimeout(renderAll, 150); }
  }, true);
  document.addEventListener("visibilitychange", function () { if (!document.hidden) renderAll(); });
  window.addEventListener("storage", function (e) { if (e.key === KEY || e.key === OKEY || e.key === null) renderAll(); });
  window.addEventListener(OEVT, renderAll);
  window.addEventListener(EVT, renderAll);
  window.addEventListener("pageshow", renderAll);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start); else start();
})();
